import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { reactive, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: { default: '' },
    size: { default: 50 },
    height: { default: 50 },
    fallback: { default: 'https://visionhealthmed.com/static/img/imgLost.png' }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const list = reactive([]);

const compatible = () => {
    list.length = 0;

    if (!props.value) return;

    if (props.value.indexOf('[') !== -1 && props.value.indexOf(']') !== -1) {
        list.push(...JSON.parse(props.value));
        return;
    }

    list.push(...props.value.split(','));
};

watch(() => props.value, (val) => {
    compatible()
}, {
    deep: true
})

compatible();

__expose({
    compatible
});


return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createBlock(_component_a_image_preview_group, null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (url, index) => {
        return (_openBlock(), _createBlock(_component_a_image, {
          key: index,
          src: url,
          width: props.size,
          height: props.height,
          fallback: props.fallback
        }, null, 8, ["src", "width", "height", "fallback"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})